<button
  type="button"
  (click)="onClick($event)"
  #exchangeCommitOrSubmitButtonClick
  class="{{ config.config.isPrimary ? 'button fm-primary-button' : 'button fm-tertiary-button' }}"
>
  {{ config.labelField }}
</button>
